import React from "react";
import "../../Assets/styles/Accomodation.css";

const stays = [
  {
    name: "Sra da Oliveira Solar Heritage | Leiria",
    link: "https://www.booking.com/hotel/pt/sra-da-oliveira-solar-heritage.pt-pt.html?label=mkt123sc-a2995b94-325d-44cc-8aef-18aa8c05c37f&sid=96994fcf35f0cbb6c9affc8932ee21ae&aid=311098&ucfs=1&arphpl=1&checkin=2026-08-14&checkout=2026-08-15&dest_id=4108283&dest_type=hotel&group_adults=2&req_adults=2&no_rooms=1&group_children=0&req_children=0&hpos=1&hapos=1&sr_order=popularity&srpvid=9a3a70c8733f0370&srepoch=1773244953&all_sr_blocks=410828304_125267650_0_1_0&highlighted_blocks=410828304_125267650_0_1_0&matching_block_id=410828304_125267650_0_1_0&sr_pri_blocks=410828304_125267650_0_1_0__7875&from=searchresults",
    button: "+ Informações",
  },
  {
    name: "B&B HOTEL | Leiria",
    link: "https://www.booking.com/hotel/pt/b-amp-b-leiria.pt-pt.html?label=mkt123sc-a2995b94-325d-44cc-8aef-18aa8c05c37f&sid=96994fcf35f0cbb6c9affc8932ee21ae&aid=311098&ucfs=1&arphpl=1&checkin=2026-08-14&checkout=2026-08-15&group_adults=2&req_adults=2&no_rooms=1&group_children=0&req_children=0&all_sr_blocks=1257464101_398289306_2_2_0&highlighted_blocks=1257464101_398289306_2_2_0&matching_block_id=1257464101_398289306_2_2_0&sr_pri_blocks=1257464101_398289306_2_2_0&from_list=1",
    button: "+ Informações",
  },
  {
    name: "TRYP by Wyndham | Leiria",
    link: "https://www.booking.com/hotel/pt/tryp-leiria.pt-pt.html?label=mkt123sc-a2995b94-325d-44cc-8aef-18aa8c05c37f&sid=96994fcf35f0cbb6c9affc8932ee21ae&aid=311098&ucfs=1&arphpl=1&checkin=2026-08-14&checkout=2026-08-15&group_adults=2&req_adults=2&no_rooms=1&group_children=0&req_children=0&all_sr_blocks=133187113_97961069_2_1_0&highlighted_blocks=133187113_97961069_2_1_0&matching_block_id=133187113_97961069_2_1_0&sr_pri_blocks=133187113_97961069_2_1_0&from_list=1",
    button: "+ Informações",
  },
  {
    name: "FOREST VILLAS - GUEST HOUSE | Leiria",
    link: "https://www.booking.com/hotel/pt/forest-villas-guest-house.pt-pt.html?label=mkt123sc-a2995b94-325d-44cc-8aef-18aa8c05c37f&sid=96994fcf35f0cbb6c9affc8932ee21ae&aid=311098&ucfs=1&arphpl=1&checkin=2026-08-14&checkout=2026-08-15&group_adults=2&req_adults=2&no_rooms=1&group_children=0&req_children=0&all_sr_blocks=1087488912_381667606_0_1_0&highlighted_blocks=1087488912_381667606_0_1_0&matching_block_id=1087488912_381667606_0_1_0&sr_pri_blocks=1087488912_381667606_0_1_0&from_list=1",
    button: "+ Informações",
  },
];

const AccommodationSection = () => {
  return (
    <section className="accommodation-section" id="accommodation">
      <div className="accommodation-content">
        <p className="accommodation-kicker">ALOJAMENTO</p>

        <h2 className="accommodation-title">
          PARA QUEM QUISER FICAR POR LEIRIA
          <br />
          E APROVEITAR A NOITE COM CALMA.
        </h2>

        <p className="accommodation-text">
          Para quem preferir pernoitar em Leiria na noite do casamento,
          deixamos abaixo algumas sugestões de alojamento. Recomendamos que
          reservem com alguma antecedência.
        </p>

        <div className="accommodation-list">
          {stays.map((stay, index) => (
            <div className="accommodation-item" key={index}>
              <div className="accommodation-item-text">
                <h3>{stay.name}</h3>
                <p>{stay.text}</p>
              </div>

              <a
                href={stay.link}
                target="_blank"
                rel="noreferrer"
                className="accommodation-btn"
              >
                {stay.button}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AccommodationSection;